import { AppLayout } from "../shared";
import SubOrganizations from "../MasterOrg/SubOrganizations";

const MasterOrgSubOrgs_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <SubOrganizations props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgSubOrgs_layout;
